import React from 'react'
import {Provider} from 'react-redux'
import reducers from './redux/reducers/reducers_task'
import {TaskLayout} from './component/task/TaskLayout'
import {BrowserRouter, Route, Routes} from 'react-router'
import {URLS} from './constants/urls'
import {SignInPageContainer} from './component/auth/SignInPageContainer'
import {createAppStore} from './redux/store'
import {createSocket} from './socket'
import {ToastContainer} from 'ac_ui'
import {SocketObserver} from './component/socket/SocketObserve'
import {FeedbackFormModalWrapper} from './component/feedback/FeedbackFormModalWrapper'

declare let __STORE__: any

const store = createAppStore(__STORE__, reducers)

global.socket = createSocket()

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path={'/courses/task/:taskId'} element={<TaskLayout />} />
          <Route path={URLS.tasks + '/:taskId/unauthorized'} element={<SignInPageContainer />} />
        </Routes>
        <SocketObserver />
        <ToastContainer />
        <FeedbackFormModalWrapper />
      </BrowserRouter>
    </Provider>
  )
}

export default App
